import React, { useState } from 'react';
import aboutImg from '../assets/images/about/about-img1.jpg';

const AboutSection = () => {
  const [activeTab, setActiveTab] = useState('who');

  const tabContent = {
    who: {
      title: "Who We Are",
      content: [
        "Z1 Technology & Trade Pvt. Ltd. is a Nepal-based IT solutions company established in 2022 by a group of experienced IT professionals who have been actively working in the software development and computer hardware trade sector since 2002.",
        "Before the establishment of Z1 Technology, our core team successfully operated under Zenith IT Solutions and Zenith Computer, delivering reliable IT services and software solutions to various sectors across Nepal.",
        "We are the creators of Purnima Co-operative ERP and Purnima Business Software, which have been widely used since 2003 by cooperatives, businesses, and institutions throughout the country.",
        "These products are known for their stability, compliance, and ease of use.",
      ]
    },
    vision: {
      title: "Our Vision",
      content: [
        "Our mission is to digitally empower organizations by providing innovative, secure, and reliable IT solutions that improve efficiency and transparency.We are committed to:",
        "Delivering high-quality software and IT services",
        "Supporting digital transformation in government and private sectors",
        "Providing dependable after-sales service and technical support",
        "Developing locally made solutions with global standards",
        "We believe technology should simplify operations, reduce costs, and enhance decision-making.",
        
      ]
    },
    history: {
      title: "Our History",
      content: [
        "20+ years of industry experience",

        "Proven ERP products used since 2003",

        "Strong government and enterprise portfolio",

        "One-stop IT solution provider.",

        "Reliable support and AMC services.",

        "Customized solutions as per client needs",
      ]
    }
  };

  return (
    <section className="about-area about-five">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-12">
            <div className="about-image-five">
              {/* SVG dots background */}
              <svg className="shape" width="106" height="134" viewBox="0 0 106 134" fill="none" xmlns="http://www.w3.org/2000/svg">
                {/* SVG dots code from original */}
                <circle cx="1.66654" cy="1.66679" r="1.66667" fill="#DADADA" />
                <circle cx="1.66654" cy="16.3335" r="1.66667" fill="#DADADA" />
                {/* Add all other circles from original SVG */}
              </svg>
              <img src={aboutImg} alt="About Z1 Technology" />
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="about-five-content">
              <h6 className="small-title text-lg">OUR STORY</h6>
              <h2 className="main-title fw-bold">Our team comes with the experience and knowledge</h2>

              <div className="about-five-tab">
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className={`nav-link ${activeTab === 'who' ? 'active' : ''}`}
                      onClick={() => setActiveTab('who')}
                    >
                      Who We Are
                    </button>
                    <button
                      className={`nav-link ${activeTab === 'vision' ? 'active' : ''}`}
                      onClick={() => setActiveTab('vision')}
                    >
                      Our Vision
                    </button>
                    <button
                      className={`nav-link ${activeTab === 'history' ? 'active' : ''}`}
                      onClick={() => setActiveTab('history')}
                    >
                      Our History
                    </button>
                  </div>
                </nav>

                <div className="tab-content" id="nav-tabContent">
                  <div className={`tab-pane fade ${activeTab === 'who' ? 'show active' : ''}`}>
                    {tabContent[activeTab].content.map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                </div>
                <div className="tab-content" id="nav-tabContent">
                  <div className={`tab-pane fade ${activeTab === 'vision' ? 'show active' : ''}`}>
                    {tabContent[activeTab].content.map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                </div>
                <div className="tab-content" id="nav-tabContent">
                  <div className={`tab-pane fade ${activeTab === 'history' ? 'show active' : ''}`}>
                    {tabContent[activeTab].content.map((paragraph, index) => (
                      <p key={index}>{paragraph}</p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;